import a from './a';
import li from './li';
import l from './l';
import h from './h';
import p from './p';
import pre from './pre';
import c from './c';
import table from './table';
import td from './td';
import th from './th';

export default {
  a,
  li,
  ul: l({ type: 'unordered' }),
  ol: l({ type: 'ordered' }),
  h1: h({ tag: 'h1', size: 'xxxl', position: 'bottom', spacing: 'm' }),
  h2: h({ tag: 'h2', size: 'xxl', position: 'topBottom', spacing: 'm' }),
  h3: h({ tag: 'h3', size: 'xl', position: 'topBottom', spacing: 'm' }),
  h4: h({ tag: 'h4', size: 'l', position: 'topBottom', spacing: 's' }),
  h5: h({ tag: 'h5', size: 'm', position: 'topBottom', spacing: 's' }),
  pre,
  p,
  c,
  table,
  td,
  th,
};



// WEBPACK FOOTER //
// ./src/components/markdown/index.js